export const ASSORTMENT_LIST_HEIGHT = 250;
